import React from 'react';

function Check16(props) {
	const fill = props.fill || 'currentColor';
	const secondaryfill = props.secondaryfill || fill;
	const width = props.width || '100%';
	const height = props.height || '100%';
	const title = props.title || "check 16";

	return (
		<svg height={height} width={width} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<title>{title}</title>
	<g fill={secondaryfill} stroke={secondaryfill} strokeWidth="1">
		<polyline fill="none" points="1,9 5,13 15,3 " stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
	</g>
</svg>
	);
};

export default Check16;